import { ChangeDetectionStrategy, Component, type OnChanges, type SimpleChanges, input, type InputSignal } from '@angular/core';
import { type FormControl, Validators } from '@angular/forms';
import { MAX_FIELD_LENGTH_DICTIONARY } from '@pecan/shared/constants/max-field-length-dictionary.constant';
import { TextInputComponent } from '@pecan/shared/components/text-input/text-input.component';
import { asciiCharsRegExp } from '@pecan/shared/constants/ascii-chars-regexp';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TextInputComponent, TranslatePipe],
    selector: 'app-city-input',
    templateUrl: './city-input.component.html',
})
export class CityInputComponent implements OnChanges {
    public readonly required: InputSignal<boolean> = input<boolean>(true);

    public readonly control: InputSignal<FormControl<string>> = input.required<FormControl<string>>();

    public maximumLength: number = MAX_FIELD_LENGTH_DICTIONARY.city;

    public ngOnChanges({ required, control }: SimpleChanges): void {
        if (required || control) {
            this._updateValidators();
        }
    }

    private _updateValidators(): void {
        const validators = [Validators.maxLength(this.maximumLength), Validators.pattern(asciiCharsRegExp)];

        if (this.required()) {
            validators.push(Validators.required);
        }

        this.control().setValidators(validators);
        this.control().updateValueAndValidity();
    }
}
